import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { MoreFilled } from '@element-plus/icons'

import { PaginationParams } from '@/models/api'
import { UserType } from '@/models/user'

import { GetReviewsParams, useReviewsStore } from '@/store/reviews'

import { normalizeUserName } from '@/helpers/user'
import { formatDateWithTime } from '@/helpers/date'
import { normalizeCarName } from '@/helpers/car-profile'
import { routeNames } from '@/router/route-names'

import useQueryParams from '@/composables/useQueryParams'
import { useAuthStore } from '@/store/auth'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    query: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const isHost = computed(() => props.query.userType === UserType.HOST)

const authStore = useAuthStore()
const reviewsStore = useReviewsStore()

const isLoading = computed(() => reviewsStore.listModule.isLoading)
const isInitialLoadingDone = computed(
  () => reviewsStore.listModule.isInitialLoadingDone
)
const error = computed(() => reviewsStore.listModule.error)
const list = computed(() => reviewsStore.listModule.list)
const meta = computed(() => reviewsStore.listModule.meta)
const isAdmin = computed(() => authStore.session?.user.role == 'admin')

const getReviews = (params: PaginationParams) => {
  reviewsStore.getReviews(params)
}

const deleteReview = async (id: string) => {
  await reviewsStore.deleteReview(id)
  await getReviews(params)
}

const params = useQueryParams<PaginationParams & GetReviewsParams>({
  ...props.query,
})

onMounted(() => {
  getReviews(params)
})

watch(
  () => props.query,
  updated => {
    Object.assign(params, updated)
  },
  { deep: true }
)

watch(params, updatedParams => {
  getReviews(updatedParams)
})

const handleRetryClick = () => {
  getReviews(params)
}

const showEntity = (routeName: string, id: string) => {
  router.push({ name: routeName, params: { id } })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: handleRetryClick
      }, null, 8, ["errorMessage"]))
    : (!isInitialLoadingDone.value || !meta.value)
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "table-container" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      style: {"width":"100%"},
                      data: list.value,
                      "element-loading-background": "rgba(255, 255, 255, 0.5)",
                      onRowClick: _cache[1] || (_cache[1] = ($event: any) => (showEntity(_unref(routeNames).reviewDetails, $event.id)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "id",
                          label: "Id"
                        }),
                        _createVNode(_component_el_table_column, null, {
                          header: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "underline-label" }, "From:", -1)),
                            _createTextVNode(" " + _toDisplayString(isHost.value ? 'host' : 'renter'), 1)
                          ]),
                          default: _withCtx(({ row: { trip } }) => [
                            _createTextVNode(_toDisplayString(_unref(normalizeUserName)(isHost.value ? trip.host : trip.renter)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "score",
                          label: "Score"
                        }),
                        _createVNode(_component_el_table_column, null, {
                          header: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "underline-label" }, "To:", -1)),
                            _createTextVNode(" " + _toDisplayString(isHost.value ? 'renter' : 'host'), 1)
                          ]),
                          default: _withCtx(({ row: { trip } }) => [
                            _createTextVNode(_toDisplayString(_unref(normalizeUserName)(isHost.value ? trip.renter : trip.host)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Vehicle" }, {
                          default: _withCtx(({ row: { trip } }) => [
                            _createTextVNode(_toDisplayString(_unref(normalizeCarName)(trip.car_profile)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Trip start date" }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(_unref(formatDateWithTime)(row.trip.start_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Trip end date" }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(_unref(formatDateWithTime)(row.trip.end_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "60px",
                          "class-name": "action-cell"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_dropdown, { trigger: "click" }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (showEntity(_unref(routeNames).reviewDetails, row.id))
                                    }, {
                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode(" Show review ")
                                      ])),
                                      _: 2,
                                      __: [5]
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (showEntity(_unref(routeNames).tripDetails, row.trip_id))
                                    }, {
                                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                                        _createTextVNode(" Show trip ")
                                      ])),
                                      _: 2,
                                      __: [6]
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (
                        showEntity(_unref(routeNames).userDetails, row.trip.host_id)
                      )
                                    }, {
                                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                                        _createTextVNode(" Show host ")
                                      ])),
                                      _: 2,
                                      __: [7]
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (
                        showEntity(_unref(routeNames).userDetails, row.trip.renter_id)
                      )
                                    }, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode(" Show renter ")
                                      ])),
                                      _: 2,
                                      __: [8]
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (
                        showEntity(
                          _unref(routeNames).vehicleDetails,
                          row.trip.car_profile_id
                        )
                      )
                                    }, {
                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createTextVNode(" Show vehicle ")
                                      ])),
                                      _: 2,
                                      __: [9]
                                    }, 1032, ["onClick"]),
                                    (isAdmin.value)
                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                          key: 0,
                                          onClick: ($event: any) => (deleteReview(row.id))
                                        }, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode(" Delete review ")
                                          ])),
                                          _: 2,
                                          __: [10]
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  size: "small",
                                  type: "text",
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, {
                                      color: "black",
                                      size: 22
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(MoreFilled))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, isLoading.value]
                    ]),
                    _createVNode(_component_el_pagination, {
                      background: "",
                      layout: "prev, pager, next",
                      total: meta.value.total,
                      disabled: isLoading.value,
                      "page-size": meta.value.perPage,
                      currentPage: _unref(params).page,
                      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(params).page) = $event))
                    }, null, 8, ["total", "disabled", "page-size", "currentPage"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})